// extracted by mini-css-extract-plugin
export const content = "double-image-module--content--1KTwM";